import type { FC } from 'react'
import styled from '@emotion/styled'

import sanitizeHtml from 'sanitize-html'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import type { PageConfig } from '@segment/contexts/page'
import { usePageConfig } from '@segment/contexts/page'

import HeroForm from './HeroForm'

const getCopy = (pageConfig: PageConfig) => ({
  overline: `Linked Profiles`,
  heading: `Request a Beta Invitation`,
  description: [
    {
      paragraph: `Linked Profiles will empower data teams and marketers to work together by bridging the gap between the two teams so marketers can expand into use cases that were never before possible. Enable marketers to build and iterate on hyper personalized campaigns quickly vs constantly working through data alignment problems.`,
    },
    {
      paragraph: `Sign up to get on the list for our beta program.`,
    },
    {
      paragraph: `Note: You must be a Unify customer to participate in the Beta. To get started with Unify, <a href="${getAbsoluteUrl(
        `/product/unify/`,
        pageConfig
      )}">request a demo here</a>.`,
    },
  ],
})

const Hero: FC = () => {
  const pageConfig = usePageConfig()
  const copy = getCopy(pageConfig)
  return (
    <Wrapper>
      <HeroRecipeBaseStyled variant="2Col" copyVariant="narrow">
        <HeroRecipe.Copy>
          <CopyText.Overline variant="h5" tag="p">
            {copy.overline}
          </CopyText.Overline>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          {copy.description.map((text, index) => (
            <CopyText.Description
              key={index}
              tag="p"
              variant="pExtraLarge"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(text.paragraph, { allowedTags: [`a`] }),
              }}
            />
          ))}
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <HeroRecipe.Form>
            <HeroForm />
          </HeroRecipe.Form>
        </HeroRecipe.Contents>
      </HeroRecipeBaseStyled>
    </Wrapper>
  )
}

const Wrapper = styled.header``

const HeroRecipeBaseStyled = styled(HeroRecipeBase)`
  ${HeroRecipe.Wrapper} {
    justify-items: flex-start;
    align-items: flex-start;
  }
`

export default Hero
